<template>
    <div class="bread">
        <!-- 柱状图表格 -->
        <template v-if="tableData.length>0">
            <div id="columnarChart"
                 ref="columnar"
                 class="columnarChart"
                 :style="{width: isMobile ? '355px' : '100%', height: isMobile ? (h + 'px') : '100%'}"></div>
        </template>

        <template v-if="tableData.length === 0">
            <div class="nodata">
                <span>
                  <img src="https://bigdata.topeti.com/PCRepository/defaultSvg/Intersect.svg" />
                  <div>暂无数据</div>
                </span>
            </div>
        </template>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import macaronsDatas from './json/echartColor.json'
import {chartParse, colorData, colorDataNew} from './js/color.js';
import { hexToRGBA } from "@/api/utils";
import { echartTemp } from '@/components/common/echartsBuilder/template/columnar.js'
let chartsModel = "";
// var curInt = null;


export default {
    name: 'columnarDetails',
    props: {
      h: Number,
        //- 分组字段数据
        row: {
            type: Array,
            default: ()=>[]
        },
        //- 汇总字段数据
        summary: {
            type: Array,
            default: ()=>[]
        },
        //- drage组件大小修改后，饼图实时更新
        changeSize: {
            type: Number,
            default: 0
        },
        parentKey: {
            type: Number,
            default: 0
        },
        //- 表格数据
        tableData: {
            type: Array,
            default: ()=>[]
        },
        //- 表id
        id: {
            type: Number,
            default: 0
        },
        // 图形样式
        echartsTempId: {
          type: Number,
          default: -1
        },
        //- isFrontEnd是否为前端或者后端展示:true为后端,false为前端
        isFrontEnd: {
            type: Boolean,
            default: ()=>false
        },
        viewShow: {
            type: Boolean,
            default: ()=>false
        },
        selectIndex: {
            type: Number,
            default: ()=>null
        },
        user: {
            type: Array,
            default: () => []
        },
        width: [String, Number],
        isMobile: {
          type: Boolean,
          default: false
        },
        theme: Object,
        column: {
          type: Array,
          default: () => []
        }
    },
    data: function () {
        return {
            myChart: '',
            nameArray: [],
            chartOption: {},
            resizeObserver: null,
            isChartInitialized: false,
        }
    },
    mounted() {
			console.log(this.$props);
        console.log("this.selectIndex==>",this.selectIndex);
        // if(this.selectIndex){
        //     curInt = this.selectIndex;
        // }
        this.$nextTick(()=>{
            this.setupResizeObserver();
            this.openFunBread();
            // this.initChart()
        })

    },
    beforeUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    },
    methods: {
        setupResizeObserver() {
            const dom = this.$refs.columnar;
            if (!dom) return;
            
            this.resizeObserver = new ResizeObserver(() => {
                if (this.isChartInitialized && this.myChart) {
                    this.myChart.resize();
                }
            });
            this.resizeObserver.observe(dom);
        },
        async initChart() {
          try {
            // 动态导入 columnar.js
            const { columnar1 } = await import('@/components/common/echartsBuilder/template/columnar.js');
            
            // 使用 ECharts 在 DOM 元素上初始化图表
            this.chartOption = columnar1
            
            
            this.openFunBread();
          } catch (error) {
            console.error('Import columnar.js failed:', error);
          }
        },
        updateFun(){
            console.log("更新");
            if (this.myChart && this.myChart.resize) {
                this.myChart.resize();
            }

        },
        //- 打开图表
        openFunBread(){
            console.log("openFun",this.tableData.length);
            // this.chartOption.series[0].itemStyle.normal.color = new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
            //     offset: 0,
            //     color: 'rgb(57,89,255,1)'
            // }, {
            //     offset: 1,
            //     color: 'rgb(46,200,207,1)'
            // }])
            if(this.tableData.length <= 25 && this.tableData.length > 0){
                this.$nextTick(()=>{
                    this.initData();
                })

            }

        },
      // series 值动态计算
      getSeries () {
        const series = []
        for (let s = 0; s < this.summary.length; s++) {
          const i = this.summary[s]
          const arr = this.tableData.map(its => its[i.title])
          if (this.theme && this.theme.axes) {
            series.push({
              data: arr,
              type: 'bar',
              barMaxWidth: 20, // 最大宽度
              barWidth: 25,
              barGap: 3,
              label: {
                normal: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#666666'
                  }
                }
              },
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                },
              },
              // 最大值气泡效果
              // markPoint: {
              //   data: [{type:"max", name: ''}]
              // }
            })
          } else {
            series.push({
              data: arr,
              type: 'bar',
              barMaxWidth: 20, // 最大宽度
              barWidth: 15,
              barGap: 2,
              label: {
                normal: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#666666'
                  }
                }
              },
              itemStyle: {
                normal: {
                  barBorderRadius: 5,
                  color: function () {
                    return colorData(s)
                  }
                },
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                },
              }
            })
          }
        }
        return series
      },
      getSeriesNew () {
        const series = []
        for (let s = 0; s < this.summary.length; s++) {
          const i = this.summary[s]
          const arr = this.tableData.map(its => its[i.title])
          if (this.theme && this.theme.axes) {
            series.push({
              name: '值',
              type: 'bar',
              zlevel: 1,
              itemStyle: {
                normal: {
                  barBorderRadius: 10,
                  color: '#fff',
                },
              },
              barWidth: 15,
              data: arr
            })
          } else {
            series.push({
              name: '值',
              type: 'bar',
              zlevel: 1,
              itemStyle: {
                normal: {
                  barBorderRadius: 10,
                  color: '#fff',
                },
              },
              barWidth: 15,
              data: arr
            })
          }
        }
        return series
      },
        //- 创建图表
        initData() {
            const that = this;
            let nameArray = []
          if (this.column && this.column.length > 0) {
            for (const i of this.tableData) {
              if (Array.isArray(i)) {
                for (const s of i) {
                  if (s) nameArray.push(s.name)
                }
              }
            }
            console.log('去重之前x轴数据', JSON.stringify(nameArray), this.column)
            // nameArray = Array.from(new Set(nameArray))
          } else {
            nameArray = this.tableData.map(val=>{
              return val.name
            })
          }
          // 去重
          nameArray = [...new Set(nameArray)];
          
          // 检查是否至少有一个值包含数字
          const hasNumbers = nameArray.some(item => /\d/.test(item));
          
          if (hasNumbers) {
              // 如果有数字，则按升序排序
              nameArray.sort((a, b) => {
                const yearA = parseInt(a);
                const yearB = parseInt(b);
                return yearA - yearB;
              });
          }
          console.log('x轴数据', nameArray)

          chartsModel = "";
            // that.tableData[0].selected = true;
          this.$nextTick(()=>{
                 // 基于准备好的dom，初始化echarts实例
                let dom = that.$refs.columnar;
                if (!dom) return
                
                // 确保容器有实际尺寸，否则延迟重试
                if (dom.offsetWidth === 0 || dom.offsetHeight === 0) {
                  setTimeout(() => {
                    that.initData();
                  }, 100);
                  return;
                }
                
                echarts.registerTheme('macarons', macaronsDatas.theme)
                chartsModel = echarts.init(dom,'macarons');

              const config =  {
                type: 'bar',
                barMaxWidth: 20, // 最大宽度                
                label: {
                  normal: {
                    show: true,
                    position: 'top',
                    fontSize: 12,     // 数值标签的字体大小
                    textStyle: {
                      color: '#666666'
                    }
                  }
                },
                itemStyle: {
                  normal: {
                    barBorderRadius: 5,
                    color: '#333'
                  },
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  },
                }
              }
              // 新增配置
              if(this.theme && Object.keys(this.theme).length > 0){
                console.log("aaaqqq");
                if(this.theme.barGap && this.theme.barWidth){
                  config.barGap = this.theme.barGap / this.theme.barWidth * 100 + '%';
                }
                config.label.normal.show = this.theme.tagTextShow
                config.label.normal.textStyle.color = this.theme.tagTextColor
                config.label.normal.textStyle.fontFamily = this.theme.tagTextFontFamily
                config.label.normal.textStyle.fontSize = this.theme.tagTextFontSize
                if(this.theme.barType === 'diy'){
                  config.barWidth = this.theme.barWidth
                }
              }

              let option = {
                  legend: {
                    top: 'top',
                    type: 'scroll',
                    textStyle: {color: '#666666'},
                    show: true
                  },
                  tooltip: {},
                    xAxis: {
                        type: 'category',
                        data: nameArray,
                        scrollbar: {
                          show: false // 显示横向滚动条
                        },
                        axisLabel: {
                          rotate: 0,
                          showMaxLabel: true,
                          interval: 0,
                          color: '#666666',
                          fontFamily: '宋体',
                          fontSize: 20,
                          formatter: function (val) {
                            return typeof val === 'string' && val ? val.split(/\1{1}/g).join('') : val
                          }
                        },
                        // 刻度设置
                        axisTick: {
                          show: true,
                          alignWithLabel: true
                        },
                        splitLine: {show: false},
                        axisLine: {
                          show: true,
                          lineStyle: {
                            color: '#D8D8D8'
                          }
                        },
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                          showMinLabel: false,
                          color: '#666666'
                        },
                        // 刻度设置
                        axisTick: {
                          show: true,
                          alignWithLabel: true
                        },
                        axisLine: {
                          show: true,
                          lineStyle: {
                            color: '#D8D8D8'
                          }
                        },
                        splitLine: {
                          show: false,
                        }
                    },
                  grid:{
                    top: this.column.length > 0 ? 45 : 20,
                    bottom: 20,
                    left: 20,
                    right: 20,
                    containLabel: true
                  },
                  series: this.column.length > 0 ? chartParse({
                    date: this.tableData, column: this.column, summary: this.summary, xAxisData: nameArray, config: config, colorFu: this.theme && this.theme.axes ? this.theme.color : colorData
                  }) : this.getSeries()
/*
                  series: [{
                        data: valueArray,
                        type: 'bar',
                        barMaxWidth: 20, // 最大宽度
                        label: {
                          normal: {
                            show: true,
                            position: 'top',
                            textStyle: {
                              color: '#666666'
                            }
                          }
                        },
                        itemStyle: {
                          normal: {
                            barBorderRadius: 5,
                            color: new echarts.graphic.LinearGradient(1,0,0,1,[{offset:0, color: '#80E0FF'}, {offset:1, color: '#50BEE2'}], false)
                          },
                          emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                          },
                        }
                    }]
*/
                };

              if (this.theme && this.theme.axes) {
                const axisIndex = this.theme.axes.findIndex(its => its.type === 'category')
                const axis = this.theme.axes[axisIndex]
                console.log('x轴数据', nameArray, axis, axisIndex, this.theme.axes)
                
                option.color = this.theme.color
                option.tooltip = {
                  trigger: this.theme.markTextAllShow === 'all' ? 'axis' : 'item',
                  backgroundColor: "rgba(255,255,255,0.95)", //设置背景图片 rgba格式
                  textStyle: {
                    color: "#333",
                    width: 'auto',
                    overflow: 'break',  // 超出宽度后自动换行
                    lineHeight: 24
                  },
                  confine: true,  // 确保tooltip不会超出图表区域
                  axisPointer: {
                    type: 'cross',
                    label: {
                      backgroundColor: '#6a7985'
                    }
                  }
                }
                option.xAxis.axisLine.show = axis.axisLineShow
                option.xAxis.axisLine.lineStyle.color = axis.axisLineColor
                option.yAxis.axisLine.show = axis.axisLineShow
                option.yAxis.axisLine.lineStyle.color = axis.axisLineColor
                option.xAxis.axisTick.show = axis.axisTickShow
                option.xAxis.axisTick.lineStyle = {color: axis.axisTickColor}
                option.yAxis.axisTick.show = axis.axisTickShow
                option.yAxis.axisTick.lineStyle = {color: axis.axisTickColor}

                option.xAxis.axisLabel.rotate = this.theme.textRotate
                option.xAxis.axisLabel.show = axis.axisLabelShow
                option.xAxis.axisLabel.color = axis.axisLabelColor
                option.xAxis.axisLabel.fontFamily = axis.axisLabelFontFamily
                option.xAxis.axisLabel.fontSize = axis.axisLabelFontSize
                option.yAxis.axisLabel.show = axis.axisLabelShow
                option.yAxis.axisLabel.color = axis.axisLabelColor
                option.yAxis.axisLabel.fontFamily = axis.axisLabelFontFamily
                option.yAxis.axisLabel.fontSize = axis.axisLabelFontSize
                // 没设置文字倾斜的时候，x坐标文字根据画布自适应显示
                if(this.theme.textRotate == 0 || this.theme.textRotate == undefined){
                  option.xAxis.axisLabel.interval = 'auto'
                }

                option.xAxis.splitLine = {
                  show: axis.splitLineShow,
                  lineStyle: {
                    color: axis.splitLineColor,
                  }
                }
                option.yAxis.splitLine = {
                  show: axis.splitLineShow,
                  lineStyle: {
                    color: axis.splitLineColor,
                  }
                }
                option.legend.textStyle.color = this.theme.legendTextColor
                option.legend.textStyle.fontSize = this.theme.legendTextFontSize
                option.legend.textStyle.fontFamily = this.theme.legendTextFontFamily
                option.legend.top = this.theme.legendPosition
                option.legend.show = this.theme.legendTextShow
                if(option.legend.top === 'top'){
                  option.grid.top = 45
                }
                else{
                  option.grid.bottom = 45
                }
                

                // 不知道为什么要加这行代码，先注释
                // delete option.series[0].itemStyle

              }






            console.log('柱状图配置', option)
              chartsModel.clear();
                // 绘制图表
                // console.log("JSON.stringify(this.chartOption)==",JSON.stringify(this.chartOption));
                
                if(JSON.stringify(this.chartOption) === '{}' || this.chartOption === undefined){
                  console.log("111");
                  
                  chartsModel.setOption(option);
                }
                else{
                  console.log("222");
                  
                  chartsModel.setOption(this.chartOption);
                }
                chartsModel.off("click");
                chartsModel.on("click", (param)=>{
                    //- 设置柱状图点击事件
                    if(that.isFrontEnd === true){
                        return;
                    }
                    console.log("柱状图点击事件=====>",param);


                    that.relevanceFun(param.name,param.value,param.dataIndex);
                });
                that.myChart = chartsModel;
                that.isChartInitialized = true;
                that.$forceUpdate();
            })
        },
        //- 饼图点击事件，在客户端时候需要筛选查询该表单设置的对应关联表单
        relevanceFun(name,val,index){
            if(this.isFrontEnd === true){
                return;
            }
            let rowName = this.row[0].name;
            let summaryName = this.summary[0].name;
            let array = {};
            const nameArr = name ? name.split(/\1{1}/g) : name;
            if (Array.isArray(nameArr)) {
              for (let i = 0; i < this.row.length; i++) {
                array[this.row[i].name] = nameArr[i]
              }
            } else {
              array[rowName] = nameArr;
            }
            array[summaryName] = val;
            let date = {
                id: this.id,
                value: array,
                selectIndex: index
            }
            if (this.user[index]) date.user = this.user[index]
            this.$emit("relevanceFun",date)
        },
        // 主题切换,配色同时变化
        changeTheme(){
          if (this.echartsTempId === 0) {

            // console.log('当前切换的内容', this.tableData, getEchartTemp({ date: this.tableData, sum: this.summary, row: this.row, column: this.column }))
            let sumArray = []
            let nameArray = []
            const color = this.theme && this.theme.color || colorDataNew
            const chart = this.chartOption && JSON.stringify(this.chartOption) !== '{}' ? JSON.parse(JSON.stringify(this.chartOption)) : echartTemp[0]

            if (this.column && this.column.length > 0) {
              for (const i of this.tableData) {
                if (Array.isArray(i)) {
                  for (const s of i) {
                    if (s) nameArray.push(s.name)
                  }
                }
              }
              // console.log('去重之前x轴数据', JSON.stringify(nameArray))
              nameArray = Array.from(new Set(nameArray))
            } else {
              nameArray = this.tableData.map(val=>{
                return val.name
              })
            }
          const config = {
            name: '值',
            type: 'bar',
            zlevel: 1,
            itemStyle: {
              normal: {
                barBorderRadius: 10,
                color: '#fff',
              },
            },
            barWidth: 15,
            data: []
          }
          if(this.theme.barType === 'diy'){
            config.barWidth = this.theme.barWidth
          }
          config.barGap = this.theme.barGap / this.theme.barWidth * 100 + '%';
          const server = this.column.length > 0 ? chartParse({
                    date: this.tableData, column: this.column, summary: this.summary, xAxisData: nameArray, config: config, colorFu: this.theme && this.theme.axes ? this.theme.color : colorData
                  }) : this.getSeriesNew()
          let iconPaths = [];
          // 如果有上传自定义图标，则传值
          if(this.theme.iconList && this.theme.iconList.length > 0){
            for(let i = 0; i < this.theme.iconList.length; i++){
              const icon = this.theme.iconList[i];
              if(icon && icon.img && icon.img.url){
                iconPaths.push(this.$imgurl + '/' + icon.img.url);
              }
            }
          }
          console.log("iconPaths==",iconPaths);
          
          for (let i = 0; i < server.length; i++) {
            sumArray = sumArray.concat(server[i].data)
            server[i].itemStyle.normal.color = new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                offset: 0,
                color: hexToRGBA(color[i], '1')
            }, {
                offset: 1,
                color: hexToRGBA(color[i], '0.3')
            }])
          }

            chart.yAxis[0].data = nameArray
            chart.yAxis[1].data = sumArray
            chart.series = server
            this.chartOption = chart
            // this.chartOption.series[0].itemStyle.normal.color = new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
            //     offset: 0,
            //     color: hexToRGBA(color[0], '1')
            // }, {
            //     offset: 1,
            //     color: hexToRGBA(color[0], '0.3')
            // }])
            console.log("tht.markTextShow==",this.theme.markTextShow);
            this.chartOption.yAxis[0].axisLabel.show = this.theme.markTextShow
            this.chartOption.yAxis[0].axisLabel.textStyle.color = this.theme.markTextColor
            this.chartOption.yAxis[0].axisLabel.textStyle.fontFamily = this.theme.markTextFontFamily
            this.chartOption.yAxis[0].axisLabel.textStyle.fontSize = this.theme.markTextFontSize
            this.chartOption.yAxis[0].axisLabel.formatter = function (value, index) {
              console.log("value==",value);
              // 动态生成icon key
              return iconPaths.length > 0 ? `{title|${value}} {icon${index}| }` : `{title|${value}}`;
            }
            // 动态生成 rich
            const rich = {
              title: {
                fontFamily: this.theme.markTextFontFamily,
                fontSize: this.theme.markTextFontSize,
                color: this.theme.markTextColor
              }
            };
            if(iconPaths.length > 0){
              // 计算最长label宽度
              let maxLabel = nameArray.reduce((a, b) => a.length > b.length ? a : b, '');
              let labelLength = maxLabel.length * 2; // 12是字体大小，30是icon宽度和间距
              this.chartOption.grid.left = Math.min(60, labelLength);
              console.log("this.chartOption.grid.left==",this.chartOption.grid.left,labelLength);
              
              for (let i = 0; i < nameArray.length; i++) {
                const iconIdx = i % iconPaths.length;
                rich[`icon${i}`] = {
                  backgroundColor: {
                    image: iconPaths[iconIdx]
                  },
                  width: 24,
                  height: 24
                };
              }
            }
            this.chartOption.yAxis[0].axisLabel.rich = rich;
            this.chartOption.yAxis[1].axisLabel.show = this.theme.tagTextShow
            this.chartOption.yAxis[1].axisLabel.textStyle.color = this.theme.tagTextColor
            this.chartOption.yAxis[1].axisLabel.textStyle.fontFamily = this.theme.tagTextFontFamily
            this.chartOption.yAxis[1].axisLabel.textStyle.fontSize = this.theme.tagTextFontSize
          }          
        }
    },
    watch: {
        changeSize(val) {
            console.log("w===>",val)
            if(this.tableData.length>0){
                setTimeout(() => {
                    this.updateFun();

                }, 1000);

            }

        },
        parentKey() {
            this.updateFun();
        },
        'tableData':{
            handler (newV) {
                // do something, 可使用this
                console.log(newV)
                if(newV && newV.length>0){
                    this.$nextTick(()=>{
                        this.$forceUpdate();
                        this.openFunBread();
                    })
                }

            },
            deep:true

        },
        'selectIndex': {
            handler(newName) {

                console.log("变话了",newName)
                this.$nextTick(()=>{
                    this.$forceUpdate();
                    this.initData();
                })
            },
            deep:true
        },
        viewShow: {
          immediate: true,
          handler () {
            this.updateFun()
          }
        },
      width: {
        immediate: true,
        handler () {
          this.updateFun()
        }
      },
      theme: {
        immediate: true,
        deep: true,
        handler (val) {
          console.log('配置更新',val)
          if(this.echartsTempId !== -1 && this.echartsTempId !== null){
            this.chartOption = echartTemp[this.echartsTempId]
            this.changeTheme()
          }
          // 默认方案
          this.initData();
        }
      },
      echartsTempId: {
        immediate: true,
        handler (val) {
          console.log('图形样式',val)
          if(val === -1){
            this.chartOption = {}
          }
          else{
            this.chartOption = echartTemp[val]
            if(val === 0){
              console.log("this.theme==",this.theme);
              this.changeTheme()
            }
          }
          this.initData();
        }
      },
    }
}
</script>

<style scoped lang="scss">
.bread {
    width: 100%;
    height: 100%;
    position: relative;

}
.nodata {
    width: 100%;
    text-align: center;
    color: #666666;
    //line-height: 244px;
    height: 100%;
    position: relative;
    span{
        display: inline-block;
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        margin-left: -29px;

    }
}





</style>
